const AUTH_TYPE_KEY = "authType";
const AUTH_TYPE_COOKIE = "bookish_auth_type";
const SHARED_DOMAIN = ".bookishcircle.com";

const isValidType = (value) => value === "author" || value === "reader";

const getCookieDomain = () => {
  const host = window.location.hostname.toLowerCase();
  return host.endsWith("bookishcircle.com") ? SHARED_DOMAIN : null;
};

export const getSharedAuthType = () => {
  const cookieValue = document.cookie
    .split(";")
    .map((entry) => entry.trim())
    .find((entry) => entry.startsWith(`${AUTH_TYPE_COOKIE}=`))
    ?.split("=")[1];

  const decoded = cookieValue ? decodeURIComponent(cookieValue) : null;
  return isValidType(decoded) ? decoded : null;
};

export const getCachedAuthType = () => {
  const cached = localStorage.getItem(AUTH_TYPE_KEY);
  return isValidType(cached) ? cached : null;
};

export const getPreferredAuthType = () => {
  return getSharedAuthType() || getCachedAuthType() || "author";
};

export const persistAuthType = (type) => {
  if (!isValidType(type)) return;

  localStorage.setItem(AUTH_TYPE_KEY, type);

  const segments = [
    `${AUTH_TYPE_COOKIE}=${encodeURIComponent(type)}`,
    "Path=/",
    "Max-Age=2592000",
    "SameSite=Lax",
  ];

  const domain = getCookieDomain();
  if (domain) segments.push(`Domain=${domain}`);

  if (window.location.protocol === "https:") {
    segments.push("Secure");
  }

  document.cookie = segments.join("; ");
};

export const clearAuthType = () => {
  localStorage.removeItem(AUTH_TYPE_KEY);

  const baseSegments = [
    `${AUTH_TYPE_COOKIE}=`,
    "Path=/",
    "Expires=Thu, 01 Jan 1970 00:00:00 GMT",
    "SameSite=Lax",
  ];

  const domain = getCookieDomain();
  const cookieWithDomain = domain
    ? [...baseSegments, `Domain=${domain}`]
    : baseSegments;

  document.cookie = cookieWithDomain.join("; ");
  document.cookie = baseSegments.join("; ");
};
